// extracted by mini-css-extract-plugin
module.exports = {"buttons":"style_buttons__3ujvx","button":"style_button__1CUQF","buttonDesktopHint":"style_buttonDesktopHint__cO9x_","amount":"style_amount__2Q6x7"};